<!-- Zweck: Stellt die HTML-Struktur für shop merkliste action info component im Frontend bereit. -->
@if (data) {
  <div (keydown)="keydown($event)" class="infobox">
    <table>
      <tr>
        <td>
          @if (data.action == 'add') {
            <span>
              <svg-icon size="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">success</svg-icon>
            </span>
          }
          @if (data.action == 'delete') {
            <span>
              <svg-icon size="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">loeschen</svg-icon>
            </span>
          }
          @if (data.action == 'mldelete') {
            <span>
              <svg-icon size="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">loeschen</svg-icon>
            </span>
          }
          @if (data.action == 'mlempty') {
            <span>
              <svg-icon size="80" [class.infoicon-green]="data.info.state == 'success'" class="infoicon">clear</svg-icon>
            </span>
          }
        </td>
        <td>
          {{data.info.message}}
        </td>
      </tr>
    </table>
  </div>
}
